import {
  convertBathToStangAndRoundTwoDecimal,
  formatCurrencyAndTwoDecimalsString
} from "@/lib/formatter";
import { DateTime } from "luxon";

export class InvoiceListPresenter {
  constructor(invoices, count) {
    const newInvoices = invoices.map(invoice => {
      // set total price
      const invoiceTotalPrice = formatCurrencyAndTwoDecimalsString(
        convertBathToStangAndRoundTwoDecimal(invoice.invoice_total_price)
      );
      const invoiceTotalPriceText = `${invoiceTotalPrice} บาท`

      // set project names
      const projectNames = invoice.project_names;
      const projectNameFormats = projectNames.map(project => {
        return projectNames.length > 1 ? `- ${project}` : project;
      });

      // set status
      let statusText = "-";
      if (invoice.status === "PENDING") {
        statusText = "รอตรวจสอบ";
      } else if (invoice.status === "REJECTED") {
        statusText = "ไม่อนุมัติ";
      } else if (invoice.status === "DOCUMENT_APPROVED") {
        statusText = "เอกสารผ่าน";
      } else if (invoice.status === "PAYMENT_APPROVED") {
        statusText = "อนุมัติ";
      } else if (invoice.status === "TRANSFERRED") {
        statusText = "เสร็จสิ้น";
      }

      return {
        id: invoice.id,
        invoiceNo: invoice.invoice_no,
        invoiceDate: DateTime.fromISO(invoice.invoice_date).toUTC(),
        invoiceTotalPrice: invoiceTotalPriceText,
        createdAt: DateTime.fromISO(invoice.created_at).toUTC(),
        projectNames: projectNameFormats,
        latestFulfilledMonth: invoice.latest_fulfilled_month,
        appointmentCount: `${invoice.appointment_count} บริการ`,
        status: statusText,
        providerName: invoice.provider_name,
      };
    });

    this.invoices = newInvoices;
    this.count = count;
  }
}



// WEBPACK FOOTER //
// ./src/components/other-web/supplier/presenters/InvoiceListPresenter .js